import { useZustandStore } from 'State/store';

//E.g. useStore('appConfig.routes')
export const useStore = (keyString) =>
  useZustandStore((state) => {
    if (keyString) {
      return keyString.split('.').reduce((obj, key) => obj[key], state);
    } else {
      return state;
    }
  });
